export const UNCATEGORIZED_LABEL = "Uncategorized";

export const categorizeItems = (items) => {
  const groups = {};

  items.forEach((item) => {
    const key = (item.category && item.category.length > 0) ? item.category : UNCATEGORIZED_LABEL;
    if (!groups[key]) {
      groups[key] = { category: key, items: [], subtotal: 0 };
    }
    groups[key].items.push(item);
    groups[key].subtotal += Number(item.total) || 0;
  });

  const ordered = Object.values(groups).filter((g) => g.category !== UNCATEGORIZED_LABEL);
  if (groups[UNCATEGORIZED_LABEL]) {
    ordered.push(groups[UNCATEGORIZED_LABEL]);
  }
  return ordered;
};
